// extracted by mini-css-extract-plugin
export default {"container":"CountDown_container__VTLCJ","content":"CountDown_content__l-s3Z","label":"CountDown_label__DK4HO"};